import { FunctionComponent, ReactElement } from "react"
import { useWellControlsContext } from "../../../context/wellControlsContext"
// component
import WellControlsTimer from "./wellControlsTimer"
import Input from "../../shared/input"
import WellControlsSmartTimer from "./wellControlsSmartTimer"
import { shouldDisableSmartMode } from "../../../util/wellControlUtil/wellControlsUtils"
// scss
import styles from "./wellControlRunMode.module.scss"
import {
    ControlDetectionType,
    NormalDistributionParametersFieldsFragment,
} from "../../../generated/graphql"

interface WellControlRunModePropsI {
    normalDistributionParametersFragment: NormalDistributionParametersFieldsFragment
    controlDetectionType: ControlDetectionType
}

const WellControlRunMode: FunctionComponent<WellControlRunModePropsI> = ({
    normalDistributionParametersFragment,
    controlDetectionType,
}) => {
    const { mean } = normalDistributionParametersFragment
    // Legacy context (TREX-820): if prior mean is [0,0], Smart should be disabled
    // for change-point detection because the well has not been tuned yet. For LowFillageOverWindow control detection, Smart should remain enabled.
    const disableSmartMode = shouldDisableSmartMode(mean, controlDetectionType)

    const {
        wellControlState: { UiState },
        handleRunModeChange,
    } = useWellControlsContext()

    let runModeDisplay: ReactElement
    switch (UiState.selectedRunMode) {
        case "On":
            runModeDisplay = <div className={styles.runModeOn}>Running</div>
            break
        case "Off":
            runModeDisplay = (
                <>
                    <div className={styles.runModeStopped}>Stopped</div>
                </>
            )
            break
        case "Smart":
            runModeDisplay = (
                <>
                    <div className={styles.runModeOn}>Smart</div>
                    <WellControlsSmartTimer />
                </>
            )

            break
        case "Timer":
            runModeDisplay = <WellControlsTimer />
            break
    }

    return (
        <>
            <div className={styles.container}>
                <Input
                    orientation="horizontal"
                    label="Run Mode"
                    specializedClass="default"
                    type="select"
                    value={UiState.selectedRunMode}
                    onChange={handleRunModeChange}
                    options={[
                        { label: "On", value: "On" },
                        { label: "Off", value: "Off" },
                        { label: "Timer", value: "Timer" },
                        {
                            label: "Smart",
                            value: "Smart",
                            disabled: disableSmartMode,
                        },
                    ]}
                    disabled={false}
                />
            </div>
            {runModeDisplay}
        </>
    )
}

export default WellControlRunMode
